const isNumeric = value => /^\d+$/.test(value);

export const parseQuery = (initialQuery, sorting, supportedFilterKeys) => {

  const filters = Object.entries(initialQuery)
    .filter(([key]) => supportedFilterKeys.includes(key))
    .reduce((arr, entry) => {
      const [key, value] = entry;
      const values = Array.isArray(value) ? value : [value];
      return arr.concat(values.map(v => ({key, value: v})));
    }, []);

  const page = isNumeric(initialQuery.page) ? Number(initialQuery.page) : 1;

  const sortBy = initialQuery[sorting.key] ? {
    key: sorting.key,
    value: initialQuery[sorting.key],
  } : null;

  const query = {
    filters,
    page,
    sortBy, 
  };


  return query;
};